// Mock data for local development

export const mockUser = {
  id: 'user_mock_123',
  email: 'agent@example.com',
  name: 'Alex Agent',
  plan: 'pro' as const,
  team_id: null,
  role: null,
  has_ai_features: true,
  created_at: Date.now() / 1000 - 86400 * 30,
};

export const mockContacts = [
  {
    id: 'contact_1',
    first_name: 'Sarah',
    last_name: 'Johnson',
    email: 'sarah.johnson@email.com',
    phone: '(555) 123-4567',
    company: 'Tech Startup Inc',
    stage: 'at_bat',
    contact_type: 'lead',
    source: 'Open House - 123 Main St',
    address_city: 'San Francisco',
    address_state: 'CA',
    tags: ['hot lead', 'first-time buyer'],
    last_contact_at: Date.now() / 1000 - 86400 * 2,
    next_contact_date: new Date(Date.now() + 86400000).toISOString().split('T')[0],
    ai_summary: 'Pre-approved for $800K. Looking for 3BR in Mission/Castro area. Works in tech, flexible on move date.',
    ai_engagement_score: 0.85,
    created_at: Date.now() / 1000 - 86400 * 14,
    recent_interactions: [
      {
        id: 'int_1',
        type: 'call',
        direction: 'outbound',
        subject: 'Follow-up on property tour',
        snippet: 'Discussed the 123 Oak St listing. She loved the backyard but concerned about kitchen size.',
        occurred_at: Date.now() / 1000 - 86400 * 2,
      },
      {
        id: 'int_2',
        type: 'email',
        direction: 'inbound',
        subject: 'RE: New listings this week',
        snippet: 'Thanks for sending! The Victorian on Pine looks interesting...',
        occurred_at: Date.now() / 1000 - 86400 * 5,
      },
    ],
  },
  {
    id: 'contact_2',
    first_name: 'Michael',
    last_name: 'Chen',
    email: 'mchen@gmail.com',
    phone: '(555) 234-5678',
    company: 'Chen Family Trust',
    stage: 'on_base',
    contact_type: 'past_client',
    source: 'Referral - James Wilson',
    address_city: 'Oakland',
    address_state: 'CA',
    tags: ['investor', 'repeat client'],
    last_contact_at: Date.now() / 1000 - 86400 * 7,
    ai_summary: 'Owns 3 investment properties. Looking to expand portfolio in East Bay. Prefers multi-family.',
    ai_engagement_score: 0.72,
    created_at: Date.now() / 1000 - 86400 * 180,
    recent_interactions: [],
  },
  {
    id: 'contact_3',
    first_name: 'Emily',
    last_name: 'Rodriguez',
    email: 'emily.r@company.com',
    phone: '(555) 345-6789',
    stage: 'on_deck',
    contact_type: 'sphere',
    source: 'Networking event',
    address_city: 'Berkeley',
    address_state: 'CA',
    tags: ['networking'],
    last_contact_at: Date.now() / 1000 - 86400 * 30,
    created_at: Date.now() / 1000 - 86400 * 60,
    recent_interactions: [],
  },
  {
    id: 'contact_4',
    first_name: 'David',
    last_name: 'Park',
    email: 'david.park@email.com',
    phone: '(555) 456-7890',
    company: 'Park & Associates',
    stage: 'hall_of_fame',
    contact_type: 'past_client',
    source: 'Past transaction',
    address_city: 'San Jose',
    address_state: 'CA',
    tags: ['VIP', 'referral source'],
    last_contact_at: Date.now() / 1000 - 86400 * 14,
    ai_summary: 'Closed 2 transactions with us. Great referral source - sent 3 clients last year.',
    ai_engagement_score: 0.95,
    created_at: Date.now() / 1000 - 86400 * 365,
    recent_interactions: [
      {
        id: 'int_3',
        type: 'meeting',
        direction: 'outbound',
        subject: 'Coffee catch-up',
        occurred_at: Date.now() / 1000 - 86400 * 14,
      },
    ],
  },
  {
    id: 'contact_5',
    first_name: 'Lisa',
    last_name: 'Thompson',
    email: 'lisa.t@mortgage.com',
    phone: '(555) 567-8901',
    company: 'First Bay Mortgage',
    stage: 'scoring_position',
    contact_type: 'referral_partner',
    source: 'Industry conference',
    tags: ['lender', 'partner'],
    last_contact_at: Date.now() / 1000 - 86400 * 3,
    ai_summary: 'Senior loan officer. Excellent rates and fast closings. Refer clients regularly.',
    created_at: Date.now() / 1000 - 86400 * 200,
    recent_interactions: [],
  },
];

export const mockLineup = {
  id: 'lineup_today',
  lineup_date: new Date().toISOString().split('T')[0],
  daily_pick: [
    {
      contact_id: 'contact_1',
      reason: 'Tour scheduled tomorrow - confirm details and address any last questions',
      best_channel: 'call',
      best_time_window: 'morning',
      engagement_signals: ['high engagement', 'responded to last email within 1hr'],
      contact: mockContacts[0],
    },
    {
      contact_id: 'contact_2',
      reason: "7 days since last contact - check in about new multi-family listing",
      best_channel: 'email',
      best_time_window: 'afternoon',
      engagement_signals: ['investor profile', 'historically quick responder'],
      contact: mockContacts[1],
    },
    {
      contact_id: 'contact_4',
      reason: 'Birthday coming up in 3 days - send a personal note',
      best_channel: 'text',
      best_time_window: 'morning',
      engagement_signals: ['VIP client', 'referral source'],
      contact: mockContacts[3],
    },
  ],
  priority_contacts: [
    {
      contact_id: 'contact_3',
      priority_rank: 1,
      priority_level: 'medium',
      reason: '30 days since last contact - time for a check-in',
      context_summary: 'Met at networking event, expressed interest in buying within 6 months',
      suggested_action: {
        type: 'email',
        message: 'Quick market update and check-in',
        best_time: 'This afternoon',
      },
      contact: mockContacts[2],
    },
    {
      contact_id: 'contact_5',
      priority_rank: 2,
      priority_level: 'low',
      reason: 'Partner relationship maintenance',
      context_summary: 'Strong referral partner - maintain relationship',
      suggested_action: {
        type: 'call',
        best_time: 'End of week',
      },
      contact: mockContacts[4],
    },
  ],
  pipeline_health: {
    total_contacts: 5,
    stage_breakdown: {
      on_deck: 1,
      at_bat: 1,
      on_base: 1,
      scoring_position: 1,
      hall_of_fame: 1,
      bench: 0,
    },
    at_risk_count: 1,
    overdue_count: 2,
  },
  total_contacts_analyzed: 5,
  generated_at: Date.now() / 1000,
  actions_taken: 0,
};

export const mockStats = {
  total: 5,
  contact_today: 3,
  overdue: 2,
  by_stage: {
    on_deck: 1,
    at_bat: 1,
    on_base: 1,
    scoring_position: 1,
    hall_of_fame: 1,
    bench: 0,
  },
};
